import { useTranslation } from 'react-i18next';

import { Form } from '../../../components/Form';
import { FormField } from '../../../components/FormField';
import { Input } from '../../../components/Input';
import { RoundedBox } from '../../../components/Shared/RoundedBox';
import { CustomSelect } from '../../../components/Shared/CustomSelect';
import { timezoneList } from '../../../utils/utils';
import { GeoAddressSelect } from '../GeoAddressSelect';

export const General = ({ formik, loading }) => {
    const { t } = useTranslation();

    const { handleChange, handleSubmit, setFieldValue, errors } = formik;
    const { name, address, email, phoneCode, phoneNumber, postCode, country, time_zone_name } = formik.values;

    const timezones = Object.keys(timezoneList).map((time) => ({ label: timezoneList[time], value: time }));

    return (
        <RoundedBox className="max-w-xl flex items-center">
            <Form handleSubmit={handleSubmit} className="w-full">
                <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                    <FormField label={t('Name')} htmlFor="name" className="col-span-6" required error={errors.name}>
                        <Input disabled={loading} id="name" type="text" name="name" onChange={handleChange} value={name} placeholder={t('Store name')} />
                    </FormField>
                    <FormField label={t('Address')} className="col-span-6" htmlFor="address" required error={errors.address}>
                        <GeoAddressSelect loading={loading} setFieldValue={setFieldValue} address={address}/>
                    </FormField>
                    <FormField label={t('Timezone')} className="col-span-6" htmlFor="time_zone_name" required error={errors.time_zone_name}>
                        <CustomSelect
                            isDisabled={loading}
                            name="time_zone_name"
                            options={timezones}
                            className="w-full mt-1"
                            onChange={({ value }) => setFieldValue('time_zone_name', value)}
                            value={{label: timezoneList[time_zone_name] || "", value: time_zone_name}}
                            placeholder={t('Select timezone')}
                        />
                    </FormField>
                    <FormField disabled popoverText="On development stage" label={t('Email')} htmlFor="email" className="col-span-6">
                        <Input disabled={loading} id="email" type="text" name="email" onChange={handleChange} value={email} placeholder="you@example.com" />
                    </FormField>
                    <FormField disabled popoverText="On development stage" label={t('Phone')} className="col-span-6 sm:col-start-1 sm:col-end-3" htmlFor="phoneCode">
                        <Input disabled={loading} id="phoneCode" type="text" name="phoneCode" onChange={handleChange} value={phoneCode} placeholder={`${t('Country Code')} (+44)`} />
                    </FormField>
                    <FormField disabled popoverText="On development stage" className="col-span-6 sm:col-start-3 sm:col-end-7">
                        <Input disabled={loading} id="phoneNumber" type="text" name="phoneNumber" onChange={handleChange} value={phoneNumber} placeholder={t('Phone')} />
                    </FormField>
                    <FormField disabled popoverText="On development stage" className="col-span-6 sm:col-span-3">
                        <Input disabled={loading} id="postCode" type="text" name="postCode" onChange={handleChange} value={postCode} placeholder={t('Post Code')} />
                    </FormField>
                    <FormField disabled popoverText="On development stage" className="col-span-6 sm:col-span-3">
                        <Input disabled={loading} type="text" name="country" onChange={handleChange} value={country} placeholder={t('Country')} />
                    </FormField>
                </div>
            </Form>
        </RoundedBox>
    );
};
